<template>
  <div :class="['gfb-form-container', { required, 'pill-error': !!error }]">
    <p v-if="label" class="w-100 font-16-500 mb-2">
      {{ label }}{{ required ? " *" : "" }}
    </p>
    <span v-if="subtitle" class="w-100 mb-2 d-block">{{ subtitle }}</span>
    <slot />
    <form-error nonInput v-if="error">{{ error }}</form-error>
  </div>
</template>

<script>
export default {
  name: "gfb-form-container",
  props: {
    label: { type: String, default: "" },
    required: { type: Boolean, default: false },
    error: { default: null },
    subtitle: { type: String, default: "" },
  },
}
</script>
